// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1a34fa59","599":"8de7539c","772":"85367b0c"}[chunkId] + ".chunk.js";
};